import { DateRangeFilter } from '../../components/DateRangeFilter';
import { FilterBar } from '../../components/FilterBar';

export function ReportDateFilter() {
  return (
    <FilterBar>
      <div className="w-full [&>section]:mb-0 [&>section]:border-0 [&>section]:bg-transparent [&>section]:p-0 [&>section]:shadow-none">
        <DateRangeFilter />
      </div>
    </FilterBar>
  );
}
